import { render } from "./Autocomplete.vue?vue&type=template&id=2c7a4192&ts=true"
import script from "./Autocomplete.vue?vue&type=script&lang=ts"
export * from "./Autocomplete.vue?vue&type=script&lang=ts"

import "./Autocomplete.vue?vue&type=style&index=0&id=2c7a4192&lang=scss"

import exportComponent from "/tmpfs/builds/maltcommunity/malt/apps/malt/node_modules/.pnpm/vue-loader@17.0.1_p6ywf2fz4v3oextcdrklqlunue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__